import Icon from "@ant-design/icons";
const GarageSvg = () => (
  <svg
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.8299 12.9633H21.8104L20.1801 9.29362C19.8685 8.5953 19.1757 8.14459 18.4106 8.14459H9.76095C8.99586 8.14459 8.3031 8.5953 7.9915 9.29362L6.36117 12.9633H6.34169C5.62946 12.9633 5.05078 13.542 5.05078 14.2542V18.7724C5.05078 19.4846 5.62946 20.0633 6.34169 20.0633V21.6992C6.34169 22.2334 6.77571 22.6674 7.30988 22.6674H9.56898C10.1032 22.6674 10.5372 22.2334 10.5372 21.6992V20.0633H17.6372V21.6992C17.6372 22.2334 18.0712 22.6674 18.6054 22.6674H20.8645C21.3987 22.6674 21.8327 22.2334 21.8327 21.6992V20.0633C22.5449 20.0633 23.1236 19.4846 23.1236 18.7724V14.2542C23.1236 13.542 22.5449 12.9633 21.8327 12.9633H21.8299ZM9.16835 9.81666C9.27129 9.58296 9.50221 9.43273 9.75817 9.43273H18.4079C18.6638 9.43273 18.8947 9.58296 18.9977 9.81666L20.3943 12.9605H7.76893L9.16557 9.81666H9.16835Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M1 24V7.62985L14.2486 1L27.1661 7.62985V23.7719"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M8.02983 17.6818C8.67518 17.6818 9.19834 17.1586 9.19834 16.5133C9.19834 15.8679 8.67518 15.3448 8.02983 15.3448C7.38449 15.3448 6.86133 15.8679 6.86133 16.5133C6.86133 17.1586 7.38449 17.6818 8.02983 17.6818Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M20.3951 17.6818C21.0404 17.6818 21.5636 17.1586 21.5636 16.5133C21.5636 15.8679 21.0404 15.3448 20.3951 15.3448C19.7497 15.3448 19.2266 15.8679 19.2266 16.5133C19.2266 17.1586 19.7497 17.6818 20.3951 17.6818Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path d="M10.9414 16.235H17.3876" stroke="#31493C" strokeMiterlimit="10" />
  </svg>
);

const GarageIcon = (props) => <Icon component={GarageSvg} {...props} />;

export default GarageIcon;
